<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<div id="header-container">
  <h1 class="title">Manage Scenarios</h1>
</div>
<mat-tab-group (selectedTabChange)="tabClick($event)" mat-stretch-tabs="false">
  <mat-tab label="All Scenarios With Associations" class="tab-title">
  </mat-tab>
  <mat-tab label="Vehicle Scenarios">
  </mat-tab>
  <mat-tab label="Propulsion Scenarios">
  </mat-tab>
  <mat-tab label="Industry Scenarios">
  </mat-tab>
</mat-tab-group>

<div class="table-functions-class default-padding d-flex gap-16">
  <app-export-button id="export-button" class="export-button"
                     [disabled]="!worksheetExportRequest"
                     [excelExportService]="excelService"
                     [worksheetExportRequest]="worksheetExportRequest">
  </app-export-button>
  <button mat-flat-button color="warn" *ngIf="this.currentScenarioType !== 'all scenarios'"
          [disabled]="selectedScenarios.length === 0"
          (click)="onClickDelete()"
          (keydown)="onClickDelete()">Delete
  </button>
</div>

<div *ngIf="currentScenarioType === 'all scenarios'" [hidden]="noData" class="gfs-table">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="allScenariosList"
    [columnDefs]="allScenariosColDef"
    [autoSizeStrategy]="autoSizeStrategy"
  />
</div>

<div *ngIf="currentScenarioType === 'vehicle'" [hidden]="noData" class="gfs-table">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="vehicleScenarios"
    [columnDefs]="vehicleScenariosColDef"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>

<div *ngIf="currentScenarioType === 'propulsion'" [hidden]="noData" class="gfs-table">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="propulsionScenarios"
    [columnDefs]="propulsionScenariosColDef"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>

<div *ngIf="currentScenarioType === 'industry'" [hidden]="noData" class="gfs-table">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="industryScenarios"
    [columnDefs]="industryScenariosColDef"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  />
</div>
